import { useEffect, useState } from 'react';
import { usersApi } from '../../api/users';

export const useQueryUser = (email: string) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<{ user: any } | undefined>();

  useEffect(() => {
    if (!email) return;
    setIsLoading(true);
    usersApi
      .list({ search: email, per_page: 1 })
      .then((res) => {
        const u = res.data.nodes[0];
        if (u) {
          setData({
            user: {
              email: u.email,
              fullName: u.full_name,
              active: u.active,
              refId: u.ref_id,
              speciality: u.speciality,
              forceResetPassword: u.force_reset_password,
              role: u.roles?.[0] ?? null,
            },
          });
        }
      })
      .catch(() => setData(undefined))
      .finally(() => setIsLoading(false));
  }, [email]);

  return { data, loading: isLoading };
};
